module.exports = __webpack_public_path__ + "img/Chat_icon2.eb327342.png";